import { Injectable } from '@angular/core';
import { UserClockInOutDataService } from '../data-services/user-clock-in-out-data.service';
import { UserClockInOutResponseModel } from '../business-entities/user-clock-in-out-response-model';
import { UserStampReportResponseModel } from '../business-entities/user-stamp-report-response-model';
import { GenericResponse } from '../business-entities/generic-response'

@Injectable({
  providedIn: 'root'
})
export class UserClockInOutService {

  userClockInOutList: UserClockInOutResponseModel[];
  userStampReportList: UserStampReportResponseModel[];
  usersList: any[];
  userClockInOutId = 0;
  isEdit = false;

  constructor(private service: UserClockInOutDataService) {
  }

  async getUserClockInOut(model: any): Promise<any> {
    await this.service
        .getUserClockInOut(model)
        .then(
            (res: GenericResponse<Array<UserClockInOutResponseModel>>) => {
                this.userClockInOutList = res.responseObject;
            }
        );

    return this.userClockInOutList;
}

  async getUserStampReport(model: any): Promise<any> {
    await this.service
        .getUserStampReport(model)
        .then(
            (res: GenericResponse<Array<UserStampReportResponseModel>>) => {
                this.userStampReportList = res.responseObject;
            }
        );

    return this.userStampReportList;
}

  async getUsers(): Promise<any> {
    await this.service
        .getUsers()
        .then(
            (res: any) => {
                this.usersList = res.responseObject;
            }
        );
    return this.usersList;
}
  async GetLocationCode() {
    return await this.service.GetLocationCode();
  }
}
